// extracted by mini-css-extract-plugin
export default {"picture":"styles_picture__7I9wT","img":"styles_img__BRox1","body":"styles_body__x7Fpx","param":"styles_param__MW-1t","inStock":"styles_inStock__+mjiU","sold":"styles_sold__x2V2S"};